var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPieChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pie-chart",
    xmlns: "http://www.w3.org/2000/svg",
    width: 124.556,
    height: 124.582,
    viewBox: "0 0 124.556 124.582",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M107.735,103.177H59.189V54.631A3.516,3.516,0,0,0,55.658,51.1a55.608,55.608,0,1,0,55.608,55.608A3.55,3.55,0,0,0,107.735,103.177ZM55.658,155.254a48.545,48.545,0,0,1-3.531-96.961v48.415a3.516,3.516,0,0,0,3.531,3.531h48.415A48.593,48.593,0,0,1,55.658,155.254Z",
    transform: "translate(-0.05 -37.734)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M309.289,55.425A55.6,55.6,0,0,0,253.681,0a3.516,3.516,0,0,0-3.531,3.531V55.608a3.516,3.516,0,0,0,3.531,3.531h52.077a3.516,3.516,0,0,0,3.531-3.531ZM257.212,52.1V7.219A48.578,48.578,0,0,1,302.1,52.1H257.212Z",
    transform: "translate(-184.733 0)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChart);
export default __webpack_public_path__ + "static/media/pie-chart.e645539a.svg";
export { ForwardRef as ReactComponent };